import { FC } from "react";
import { Button, ButtonProps, Spinner } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";

export interface ButtonProcessingProps extends ButtonProps {
  readonly loading: boolean;
}

export const ButtonProcessing: FC<ButtonProcessingProps> = ({ children, loading, ...props }) => {
  return (
    <Button {...props} disabled={loading || props.disabled}>
      {loading ? (
        <Shelf spacing="small">
          <Spinner size="regular" />
          <span>Processing</span>
        </Shelf>
      ) : (
        children
      )}
    </Button>
  );
};
